@use '../../../../../app/styles/common/colors';
@use '../../../../../app/styles/common/mixins';

.deliveryCard {
  position: relative;
  flex-shrink: 0;
  height: 170px;
  width: 120px;
  padding: 12px;
  border-radius: 16px;
  background: colors.$greyBack url('./img/img.png') no-repeat left -12px bottom -28px / 102px;
  cursor: pointer;

  @include mixins.tablet {
    height: 244px;
    width: 204px;
    background-position: left -24px bottom -36px;
    background-size: 150px;
  }

  @include mixins.laptop {
    width: 160px;
    height: 220px;
  }

  @include mixins.desktop {
    width: 180px;
  }

  .deliveryText {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    max-width: 120px;
  }

  &:hover {
    .deliveryText {
      color: colors.$primaryCrimson;
    }
  }
}

.icon {
  display: inline-flex;
  position: absolute;
  bottom: 12px;
  right: 12px;
  align-items: center;
  justify-content: center;
  background-color: colors.$white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
}
